function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import Checkbox from './checkbox.js';
export default {
  name: buildComponentName('CheckboxGroup'),
  provide: function provide() {
    return {
      checkboxGroupRoot: this
    };
  },
  components: {
    Checkbox: Checkbox
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-checkbox-group'
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerValue: []
    };
  },
  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, prefixCls, true);
    },
    normalizeOptions: function normalizeOptions() {
      var _this$options = this.options,
          options = _this$options === void 0 ? [] : _this$options;
      return options.map(function (v) {
        var ret = v;

        if (typeof v === 'string') {
          ret = {
            label: v,
            value: v
          };
        }

        return ret;
      });
    }
  },
  watch: {
    value: function value(nVal) {
      this.innerValue = nVal;
    }
  },
  created: function created() {
    this.innerValue = this.value;
  },
  methods: {
    toggleCheckbox: function toggleCheckbox(optVal) {
      // fix http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/309
      // 理论上应该全面放开，但是原作者认为有场景需要限制，暂时先放开0
      if (!optVal && optVal !== 0) {
        return;
      }

      var innerValue = this.innerValue;

      var nVal = _toConsumableArray(innerValue);

      var idx = nVal.indexOf(optVal);

      if (idx !== -1) {
        nVal.splice(idx, 1);
      } else {
        nVal.push(optVal);
      }

      this.$emit('change', nVal, _toConsumableArray(innerValue));
      this.$emit('input', nVal);
      this.innerValue = nVal;
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        classes = this.classes,
        normalizeOptions = this.normalizeOptions;
    var opts = normalizeOptions;
    var checkboxs = opts.length > 0 ? opts.map(function (v) {
      return h("checkbox", {
        "class": "".concat(prefixCls, "-item"),
        "attrs": {
          "value": v.value,
          "disabled": v.disabled,
          "label": v.label
        }
      });
    }) : this.$slots.default;
    return h("div", {
      "class": classes
    }, [checkboxs]);
  }
};